var _excluded = ["children", "className", "isDisabled", "isNested", "isSelected", "onClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { bool, node, string } from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import clsx from 'clsx';
var StyledListItem = styled(ListItem)(function (_ref) {
  var _overrides$sovosNavig, _overrides$sovosNavig2, _overrides$sovosNavig3, _overrides$sovosNavig4;
  var _ref$theme = _ref.theme,
    overrides = _ref$theme.overrides,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing,
    transitions = _ref$theme.transitions;
  return {
    backgroundColor: alpha(palette.primary.light, 0.0),
    borderRadius: spacing(0.5),
    color: (_overrides$sovosNavig = overrides === null || overrides === void 0 || (_overrides$sovosNavig2 = overrides.sovosNavigation) === null || _overrides$sovosNavig2 === void 0 ? void 0 : _overrides$sovosNavig2.navItemForeground) !== null && _overrides$sovosNavig !== void 0 ? _overrides$sovosNavig : palette.primary.contrastText,
    display: 'flex',
    height: spacing(4.25),
    transition: "background-color ".concat(transitions.duration.short, "ms"),
    width: 'auto',
    '&:hover': {
      backgroundColor: (_overrides$sovosNavig3 = overrides === null || overrides === void 0 || (_overrides$sovosNavig4 = overrides.sovosNavigation) === null || _overrides$sovosNavig4 === void 0 ? void 0 : _overrides$sovosNavig4.navItemHover) !== null && _overrides$sovosNavig3 !== void 0 ? _overrides$sovosNavig3 : alpha(palette.primary.light, 0.08)
    },
    '&.sovosNavigationLinks__link--selected': {
      backgroundColor: alpha(palette.primary.light, 0.12),
      color: palette.primary.contrastText
    },
    '&.sovosNavigationLinks__link--disabled': {
      cursor: 'not-allowed'
    }
  };
});
var BaseLink = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
    _ref2$isNested = _ref2.isNested,
    isNested = _ref2$isNested === void 0 ? false : _ref2$isNested,
    isSelected = _ref2.isSelected,
    onClick = _ref2.onClick,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledListItem, _extends({
    component: "li",
    button: true,
    disableRipple: true,
    className: clsx('sovosNavigationLinks__link', className, {
      'sovosNavigationLinks__link--nested': isNested,
      'sovosNavigationLinks__link--selected': isSelected,
      'sovosNavigationLinks__link--disabled': isDisabled
    }),
    onClick: onClick,
    "aria-current": isSelected ? 'page' : undefined
  }, rest, {
    ref: ref,
    role: "link"
  }), children);
});
BaseLink.propTypes = {
  children: node.isRequired,
  className: string,
  isDisabled: bool,
  isNested: bool,
  isSelected: bool.isRequired,
  onClick: function onClick(props) {
    var isDisabled = props.isDisabled,
      onClick = props.onClick;
    if (!isDisabled && !onClick) {
      return new Error("Required prop onClick not supplied to" + " `".concat(props.component, "`. Validation failed."));
    }
    return null;
  }
};
export default BaseLink;